// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import {setUser} from '@/assets/js/utils/auth'
import VueScroller from "vue-scroller"
import 'vueg/css/transition-min.css'

import 'vant/lib/index.css'


// setUser(sessionStorage.getItem('wx-user'))
Vue.config.productionTip = false

import '@/assets/js/utils/vant'
import '@/assets/js/utils/plugin'
import '@/assets/js/utils/component'


import mixin from '@/assets/js/utils/mixin'
mixin(Vue)

import * as custom from '@/assets/js/utils/filters'
const FastClick = require('fastclick')
FastClick.attach(document.body)

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})
Vue.use(VueScroller)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js